import posthog from "posthog-js";
import { User, StripeSubscription } from "../docuclipper/DocuclipperTypes";

let initialized = false;

export const initPostHog = () => {
  if (initialized) return;
  const force = process.env.REACT_APP_POSTHOG_FORCE === "1";
  if (process.env.NODE_ENV !== "production" && !force) return;

  const key = process.env.REACT_APP_POSTHOG_KEY;
  const host = process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com";
  if (!key) return;

  try {
    posthog.init(key, {
      api_host: host,
      person_profiles: "identified_only",
      capture_pageview: true,
      capture_pageleave: true,
      autocapture: false,
      session_recording: {
        // Match Sentry replay's posture: customers upload bank statements,
        // invoices, checks, and tax forms. Anything rendered on-screen could
        // be PII (account numbers, names, SSNs, dollar amounts). Replays
        // still capture structure/interactions for UX work; only text is
        // masked.
        maskAllInputs: true,
        maskTextSelector: "*",
        blockSelector:
          "canvas, .pdf-canvas, [class*='PdfViewer'], [class*='PDFViewer'], video, audio",
      },
      disable_session_recording: false,
    });
    initialized = true;
  } catch (e) {
    // swallow; posthog should never break the app
  }
};

export const identifyPostHogUser = (user: User | null) => {
  if (!initialized) return;
  try {
    if (!user) {
      posthog.reset();
      return;
    }
    const id = user.id?.toString() || user.email;
    if (!id) return;
    posthog.identify(id, {
      email: user.email,
      user_id: user.id,
    });
  } catch (e) {
    // ignore
  }
};

export const setPostHogSubscription = (subscription: StripeSubscription | null) => {
  if (!initialized) return;
  try {
    posthog.setPersonProperties({
      subscription_status: subscription?.status || "none",
      subscription_plan: (subscription as any)?.plan?.nickname || null,
    });
  } catch (e) {
    // ignore
  }
};

export const capturePostHogEvent = (
  event: string,
  properties: Record<string, unknown> = {}
) => {
  if (!initialized) return;
  try {
    posthog.capture(event, properties);
  } catch (e) {
    // ignore
  }
};

export const resetPostHog = () => {
  if (!initialized) return;
  try {
    posthog.reset();
  } catch (e) {
    // ignore
  }
};
